import { UiSurface, uiSurface } from "shared/ui/uiSurface"
import { Box, Tab, Tabs } from "@mui/material"
import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import { useGetOrderDetailByIdQuery } from "src/app/apis"
import { OrderDetailViewType } from "../constants"
import { OrderDetailView } from "./OrderDetailView"
import { OrderTraceabilityView } from "./OrderTraceabilityView"

interface OrderDetailViewContainerProps {
  currentTab: OrderDetailViewType
  orderId: number
}

export const OrderDetailViewContainer: FC<OrderDetailViewContainerProps> = ({
  orderId,
  currentTab,
}) => {
  const tabList: OrderDetailViewType[] = ["order", "manifest", "tracking"]
  const { t } = useTranslation()
  const [currentTabView, setCurrentTab] = useState(currentTab)
  const {
    data: orderDetail,
    isFetching: isLoading,
    error: error,
  } = useGetOrderDetailByIdQuery(orderId)

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          {...uiSurface("UI-DSP-024")}
          data-testid="order-detail-tabs"
          value={currentTabView}
          onChange={(event, value) => setCurrentTab(value)}
          textColor="primary"
          indicatorColor="primary"
        >
          {tabList.map((detailType) => {
            return (
              <Tab
                data-testid={`order-detail-tab-${detailType}`}
                key={detailType}
                label={t(detailType as string)}
                value={detailType}
              />
            )
          })}
        </Tabs>
      </Box>
      <TabPanel currentTabView={currentTabView} tab={"order"}>
        <OrderDetailView isLoading={isLoading} orderDetail={orderDetail} />
      </TabPanel>
      <TabPanel currentTabView={currentTabView} tab={"manifest"}>
        <UiSurface id="UI-DSP-026">No Items in Manifest</UiSurface>
      </TabPanel>
      <TabPanel currentTabView={currentTabView} tab={"tracking"}>
        <OrderTraceabilityView
          isLoading={isLoading}
          orderDetail={orderDetail}
        />
      </TabPanel>
    </>
  )
}

const TabPanel: FC<{
  /* TODO: apply this tab to orderListByStatus component */
  children?: React.ReactNode
  tab: OrderDetailViewType
  currentTabView: OrderDetailViewType
}> = ({ currentTabView, tab, children, ...props }) => {
  return (
    <Box
      component={"div"}
      role="tabpanel"
      hidden={currentTabView !== tab}
      {...props}
    >
      {currentTabView === tab && <Box sx={{ p: 3 }}>{children}</Box>}
    </Box>
  )
}
